import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel } from '../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllocationViewCoupleActionService {
  constructor(private http: WrapperHttpService) {}

  couple(actionIdentifier: AllocationViewActionIdentifierModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.SwapBody}${AllocationViewEndpoint.Truck}${AllocationViewEndpoint.Couple}`;

    return this.http.withLoading().post<void>(url, actionIdentifier);
  }
}
